/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateEventActorTypeSchema = z.enum(['recruiter', 'candidate', 'system'])

export type CandidateEventActorTypeSchema = z.infer<typeof candidateEventActorTypeSchema>
